export enum ConnectStatus {
    Disconnect = 0, // 断开连接
    Connected = 1, // 连接成功
    Connecting = 2, // 连接中
    ConnectFail = 3, // 连接错误
    ConnectKick = 4, // 连接被踢，服务器要求客户端断开（一般是账号在其他地方登录，被踢）
}

export type ConnectStatusListener = (
    status: ConnectStatus,
    reasonCode?: number,
) => void;

export type EventListener = ( type: string, payload?: any ) => void;

export interface SocketConfig {
    url?: string;
    heartbeatInterval?: number;
    reconnectInterval?: number;
    pingMaxRetryCount?: number;
}
